import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/observable';

@Injectable({
  providedIn: 'root'
})
export class PredictionserviceService {

  constructor(private http:HttpClient) { }

  baseUrl="https://isuweb.herokuapp.com/predict/";
  base="https://isuweb.herokuapp.com/feedback/";
  httpHeaders= new HttpHeaders({'Content-Type':'application/json'})

  feed(b):Observable<any>{
    const body={email:b.email,name:b.name,comment:b.comment,satisfaction:b.satisfaction};
    console.log("In service ");
    return this.http.post(this.base,body,
    {headers:this.httpHeaders});
  }

  userPrediction(b):Observable<any>{
    const body={thal:b.thal,slope:b.slope,ca:b.ca,exang:b.exang,oldpeak:b.oldpeak,thalach:b.thalach,
      restecg:b.restecg,fbs:b.fbs,chol:b.chol,cp:b.cp,trestbps:b.thestbps,age:b.age,sex:b.sex
    };
    console.log("In service ");
    return this.http.post(this.baseUrl,body,
    {headers:this.httpHeaders});
  }


}
